import { render } from "./ContactoView.vue?vue&type=template&id=d682363e&lang=true"
import script from "./ContactoView.vue?vue&type=script&lang=js"
export * from "./ContactoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__